"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64Decode = exports.base64Encode = exports.base64ToBytes = exports.bytesToBase64 = void 0;
const bytesToBase64 = (bytes) => {
    return btoa(String.fromCharCode(...bytes));
};
exports.bytesToBase64 = bytesToBase64;
const base64ToBytes = (str) => {
    return Uint8Array.from(atob(str), (c) => c.charCodeAt(0));
};
exports.base64ToBytes = base64ToBytes;
const base64Encode = (str) => {
    const encoder = new TextEncoder();
    return (0, exports.bytesToBase64)(encoder.encode(str));
};
exports.base64Encode = base64Encode;
const base64Decode = (str) => {
    const decoder = new TextDecoder();
    return decoder.decode((0, exports.base64ToBytes)(str));
};
exports.base64Decode = base64Decode;
//# sourceMappingURL=base64.js.map